import { SUPPORT_EMAIL } from '@/constants/dc/default';
import { ROUTES } from '@/constants/routes/default';
import { getFullYear } from '@/helpers/date';
import FooterLogo from '@/components/svgs/dc/footer-logo';
import IconMail from '@/components/svgs/dc/mail-icon';
import IconPhone from '@/components/svgs/dc/phone-icon';
import Link from 'next/link';

const FooterDC = ({ isAuthorized }: { isAuthorized: boolean }) => {
  return (
    <footer className="flex md:px-10 max-md:px-4 py-7 min-h-50 bg-dc-cod-gray">
      <div className="max-w-260 w-full h-full max-md:block md:flex flex-col justify-between m-auto gap-4">
        <div className="flex flex-wrap justify-between gap-4">
          <div className="flex flex-col gap-4 max-w-46.25">
            <FooterLogo className="h-13.75 w-30 shrink-0" role="img" aria-label="David Careers" />
            <p className="text-white/60 text-sm">Jobs matched to the work you actually want.</p>
          </div>
          <nav aria-label="Footer">
            <Link
              className="block w-fit text-sm font-bold text-white default-transition hover:text-dc-vermilion mt-2"
              href={ROUTES.home}
            >
              Home
            </Link>
            <Link
              className="block w-fit text-sm font-bold text-white default-transition hover:text-dc-vermilion mt-2"
              href={ROUTES.about}
            >
              About
            </Link>
            <Link
              className="block w-fit text-sm font-bold text-white default-transition hover:text-dc-vermilion mt-2"
              href={ROUTES.jobs}
            >
              Find Jobs
            </Link>
            {isAuthorized ? (
              <Link
                className="block w-fit text-sm font-bold text-white default-transition hover:text-dc-vermilion mt-2"
                href={ROUTES.profile}
              >
                Career Profile
              </Link>
            ) : (
              <Link
                className="block w-fit text-sm font-bold text-white default-transition hover:text-dc-vermilion mt-2"
                href={ROUTES.signup}
              >
                Register
              </Link>
            )}
            <Link
              className="block w-fit text-sm font-bold text-white default-transition hover:text-dc-vermilion mt-2"
              href={ROUTES.partners}
            >
              Partners
            </Link>
            <Link
              className="block w-fit text-sm font-bold text-white default-transition hover:text-dc-vermilion mt-2"
              href={ROUTES.termsOfUse}
            >
              Terms of Use
            </Link>
            <Link
              className="block w-fit text-sm font-bold text-white default-transition hover:text-dc-vermilion mt-2"
              href={ROUTES.privacyPolicy}
            >
              Privacy Policy
            </Link>
          </nav>
          <div className="flex flex-col items-center gap-3">
            <a
              className="w-full flex items-center gap-2 py-2 px-3 bg-white/10 default-transition hover:bg-white/15 rounded-lg text-sm font-bold text-white"
              href={`mailto:${SUPPORT_EMAIL}`}
            >
              <div className="w-7 h-7 flex items-center justify-center bg-dc-vermilion16 rounded-lg">
                <IconMail
                  aria-hidden="true"
                  className="w-3.5 h-2.5 shrink-0 [&_path]:fill-dc-vermilion"
                />
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-white font-bold text-sm">{SUPPORT_EMAIL}</p>
                <p className="text-white/60 text-xs">We reply within a day</p>
              </div>
            </a>

            <a
              className="w-full flex items-center gap-2 py-2 px-3 bg-white/10 default-transition hover:bg-white/15 rounded-lg text-sm font-bold text-white"
              href="tel:800-470-8150"
            >
              <div className="w-7 h-7 flex items-center justify-center bg-dc-vermilion16 rounded-lg">
                <IconPhone
                  aria-hidden="true"
                  className="w-3 h-3 shrink-0 [&_path]:fill-dc-vermilion"
                />
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-white font-bold text-sm">800-470-8150</p>
                <p className="text-white/60 text-xs">Mon-Fri, 9am-6pm PT</p>
              </div>
            </a>
            <p className="text-sm text-white/60">2443 Fillmore St. San Francisco, CA 94115</p>
          </div>
        </div>
        <p className="text-sm text-white/60">
          Copyright &copy; {getFullYear()}, David Careers. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default FooterDC;
